// GoogleMapPicker.js
import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '300px'
};

const defaultCenter = {
  lat: 40.7128,  // Example default: New York City
  lng: -74.0060,
};

export default function GoogleMapPicker({ onLocationSelect }) {
  const [marker, setMarker] = useState(null);

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const position = { lat, lng };
    setMarker(position);
    onLocationSelect(position);
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyBBfpoVAWYZaujXG5t93mFIJKqk3cwHynw">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={marker || defaultCenter}
        zoom={13}
        onClick={handleMapClick}
      >
        {marker && <Marker position={marker} />}
      </GoogleMap>
    </LoadScript>
  );
}
